import { render, staticRenderFns } from "./MainMenuBengkulu.vue?vue&type=template&id=b31447f4&lang=pug"
import script from "./MainMenuBengkulu.vue?vue&type=script&lang=js"
export * from "./MainMenuBengkulu.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/bengkulu/menu-bkl.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports